function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.onVariantChange = this.onVariantChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  connectedCallback() {
    this.addEventListener('change', this.handleChange);
    this.currentVariant = this.getCurrentVariant();
  }

  handleChange(event) {
    const input = this.getInputForEventTarget(event.target);
    this.updateSelectionMetadata(event);
    this.onVariantChange(input);
  }

  async onVariantChange(input) {
    this.checkForQuickview();
    this.toggleAddButton(true, '', false);
    this.removeErrorMessage();

    const optionValueIds = this.getSelectedOptionValueIds();
    const productUrl = input?.dataset.productUrl || this.dataset.url;

    try {
      const html = await this.fetchProductHtml(productUrl, optionValueIds);
      if (!html) throw new Error('Unable to load product HTML');

      this.dataset.url = productUrl;
      const freshMarkup = this.updateVariantSelectors(html);
      this.currentVariant = this.parseVariantFromMarkup(freshMarkup);

      window.dispatchEvent(new CustomEvent('loft:Product:Variant__Changed', {
        detail: this.currentVariant,
      }));

      if (!this.currentVariant) {
        this.setUnavailable();
        return;
      }

      this.updateURL(productUrl);
      this.updateVariantInput();
      this.updateProductInfo(html);
      this.updatePickupAvailability();
      this.updateShareUrl(productUrl);
    } catch (error) {
      console.error(error);
      this.setUnavailable();
    }
  }

  checkForQuickview() {
    const quickviewContainer = document.querySelectorAll('[data-is-quickview="true"]');
    if (quickviewContainer.length > 0) {
      this.productContainerId = `${this.dataset.section}-quickview`;
    } else {
      this.productContainerId = `${this.dataset.section}`;
    }
  }

  getCurrentVariant() {
    const script = this.querySelector('[data-selected-variant]');
    if (!script || !script.textContent.trim()) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.warn('Unable to parse selected variant data', error);
      return null;
    }
  }

  getSelectedOptionValueIds() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked'))
      .map(({ dataset }) => dataset.optionValueId)
      .filter((id) => !!id);
  }

  fetchProductHtml(productUrl, optionValueIds = []) {
    const params = new URLSearchParams();
    params.append('section_id', this.dataset.section);
    if (optionValueIds.length) {
      params.append('option_values', optionValueIds.join(','));
    }

    return fetch(`${productUrl}?${params.toString()}`)
      .then((response) => {
        if (!response.ok) throw response;
        return response.text();
      })
      .then((text) => new DOMParser().parseFromString(text, 'text/html'));
  }

  updateVariantSelectors(html) {
    const selector = `variant-selects[data-section="${this.dataset.section}"]`;
    const freshVariantSelects = html.querySelector(selector);
    if (!freshVariantSelects) return null;

    this.innerHTML = freshVariantSelects.innerHTML;
    return freshVariantSelects;
  }

  parseVariantFromMarkup(markup) {
    const variantSource = markup?.querySelector('[data-selected-variant]') || this.querySelector('[data-selected-variant]');
    if (!variantSource || !variantSource.textContent.trim()) return null;
    try {
      return JSON.parse(variantSource.textContent);
    } catch (error) {
      console.warn('Unable to parse variant data from markup', error);
      return null;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if(this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => {
      parent.scrollLeft = 0;
      parent.querySelector('li.product__media-item').scrollIntoView({behavior: 'smooth'});
    });
  }

  updateURL(productUrl) {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${productUrl}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl(productUrl) {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${productUrl}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {

    const productForms = document.querySelectorAll(`#product-form-${this.productContainerId}, #product-form-installment`);

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  updateProductInfo(html) {
    const id = `price-${this.productContainerId}`;
    const inventoryId = `inventory-${this.productContainerId}`;
    const skuId = `sku-${this.productContainerId}`;
    const price = document.getElementById(id);

    const sourcePrice = html.getElementById(`price-${this.dataset.section}`);
    if (sourcePrice && price) price.innerHTML = sourcePrice.innerHTML;

    if (price) price.classList.remove('visibility-hidden');
    this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

    const inventoryDestination = document.getElementById(inventoryId);
    const inventorySource = html.getElementById(`inventory-${this.dataset.section}`);
    if (inventorySource && inventoryDestination) {
      inventoryDestination.innerHTML = inventorySource.innerHTML;
      inventoryDestination.classList.remove('visibility-hidden');
    }

    const skuDestination = document.getElementById(skuId);
    const skuSource = html.getElementById(`sku-${this.dataset.section}`);
    if (skuSource && skuDestination) {
      skuDestination.innerHTML = skuSource.innerHTML;
      skuDestination.classList.remove('visibility-hidden');
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {

    const productForm = document.getElementById(`product-form-${this.productContainerId}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {

    const price = document.getElementById(`price-${this.productContainerId}`);
    const inventory = document.getElementById(`inventory-${this.productContainerId}`);
    const button = document.getElementById(`product-form-${this.productContainerId}`);
    if (!button) return;
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = addButton?.querySelector('span');

    if (addButtonText) addButtonText.textContent = window.variantStrings.unavailable;
    if (addButton) addButton.setAttribute('disabled', 'disabled');
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        ?.removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`)?.querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }
}

customElements.define('variant-selects', VariantSelects);

class SubscriptionOptions extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onPlanChange);
  }


  onPlanChange(event){
    let newSelection = event.target.value;
    this.sellingPlanId = newSelection;
    this.updateSellingPlanInput()
  }

  updateSellingPlanInput() {
    let quickviewContainer = document.querySelectorAll('[data-is-quickview="true"]');
    if(quickviewContainer.length > 0){
      this.productContainerId = `${this.dataset.section}-quickview`;
    } else {
      this.productContainerId = `${this.dataset.section}`;
    }

    const sellingPlanForm = document.querySelector(`#product-form-${this.productContainerId}`);
    const input = sellingPlanForm.querySelector('input[name="selling_plan"]');
    input.value = this.sellingPlanId;

    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  updateMasterId() {
    this.sellingPlanId = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  

}

customElements.define('subscription-options', SubscriptionOptions);

document.addEventListener('DOMContentLoaded', function () {
  if (!window.__loftMenuImageHoverInitialized) {
    window.__loftMenuImageHoverInitialized = true;

    if (window.matchMedia && window.matchMedia('(min-width: 769px)').matches) {
      document.querySelectorAll('.single-dropdown').forEach((dropdown) => {
        const menuImages = Array.from(dropdown.querySelectorAll('.menu-image'));

        if (!menuImages.length) return;

        const getFirstAvailableImage = () => {
          return menuImages.find((image) => {
            const src = image.getAttribute('src');
            return src && src.trim() !== '';
          }) || null;
        };

        const showImage = (targetImage) => {
          menuImages.forEach((image) => {
            image.classList.toggle('active', image === targetImage);
          });
        };

        const showLinkImage = (link) => {
          const item = link.closest('.child-site-nav__link');
          const menuIndex = item?.dataset.menuIndex;
          if (!menuIndex) return;

          const targetImage = menuImages.find((image) => image.dataset.menuIndex === menuIndex);
          if (targetImage) showImage(targetImage);
        };

        const showFallbackImage = () => {
          const fallbackImage = getFirstAvailableImage();
          if (fallbackImage) showImage(fallbackImage);
        };

        showFallbackImage();

        dropdown.querySelectorAll('.child-site-nav__link .site-nav__link').forEach((link) => {
          link.addEventListener('mouseenter', () => showLinkImage(link));
          link.addEventListener('focus', () => showLinkImage(link));
          link.addEventListener('mouseleave', showFallbackImage);
          link.addEventListener('blur', showFallbackImage);
        });
      });
    }
  }

  if (window.__loftVatToggleInitialized) return;
  window.__loftVatToggleInitialized = true;

  const vatRate = 0.2;
  const customerVatDefault = window.customerVatDefault === 'exc' ? 'exc' : 'inc';
  const storedVatDefault = sessionStorage.getItem('vatPreferenceDefault');
  let storedVatPreference = sessionStorage.getItem('vatPreference');

  if (storedVatDefault !== customerVatDefault) {
    storedVatPreference = customerVatDefault;
    sessionStorage.setItem('vatPreference', customerVatDefault);
    sessionStorage.setItem('vatPreferenceDefault', customerVatDefault);
  } else if (storedVatPreference !== 'inc' && storedVatPreference !== 'exc') {
    storedVatPreference = customerVatDefault;
    sessionStorage.setItem('vatPreference', customerVatDefault);
  }

  let showIncVAT = storedVatPreference === 'inc';

  function formatPrice(price) {
    return price.toLocaleString('en-GB', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function getVatPriceElements(scope) {
    const elements = [];

    if (scope.nodeType === 1 && scope.matches('.vat-price')) {
      elements.push(scope);
    }

    if (scope.querySelectorAll) {
      elements.push(...scope.querySelectorAll('.vat-price'));
    }

    return elements;
  }

  function updatePrices(scope = document) {
    getVatPriceElements(scope).forEach((el) => {
      if (el.classList.contains('no-vat')) return;

      const rawBasePrice = el.hasAttribute('content') ? el.getAttribute('content') : el.dataset.basePrice;
      const basePrice = parseFloat(rawBasePrice);
      if (isNaN(basePrice)) return;

      const displayPrice = showIncVAT ? basePrice : basePrice / (1 + vatRate);
      const formattedPrice = `£${formatPrice(displayPrice)}`;
      const isComparePrice =
        el.classList.contains('js-cart-item-orig-price') ||
        el.closest('.compare-price') ||
        el.closest('s');

      el.innerHTML = isComparePrice
        ? formattedPrice
        : `<span class="font_bold" >${formattedPrice} </span><span class="vat-label">${showIncVAT ? 'inc. VAT' : 'exc. VAT'}</span>`;
    });
  }

  function updateLabelTexts() {
    const label = showIncVAT ? 'Inc. VAT' : 'Exc. VAT';
    document.querySelectorAll('.vat-label-text').forEach((el) => {
      el.textContent = label;
    });
  }

  function updateToggleStates() {
    document.querySelectorAll('.vat-toggle').forEach((toggle) => {
      toggle.checked = showIncVAT;
    });
  }

  function setVatBasePrice(el, value) {
    if (!el || el.dataset.basePrice === value) return;
    el.dataset.basePrice = value;
  }

  function syncCartPriceBaseData() {
    const cartItems = document.querySelectorAll('.js-cart-item-info-container');
    let subtotalCents = 0;

    cartItems.forEach((item) => {
      const quantityInput = item.querySelector('.quantity__input');
      const quantity = parseInt(quantityInput ? quantityInput.value : '1', 10) || 1;
      const unitPriceCents = parseFloat(item.dataset.price);

      if (!isNaN(unitPriceCents)) {
        const linePriceCents = unitPriceCents * quantity;
        subtotalCents += linePriceCents;

        const linePrice = item.querySelector('.js-cart-item-price.vat-price');
        if (linePrice) {
          setVatBasePrice(linePrice, (linePriceCents / 100).toFixed(2));
        }
      }

      const originalUnitPriceCents = parseFloat(item.dataset.origPrice);
      const originalPrice = item.querySelector('.js-cart-item-orig-price.vat-price');
      if (originalPrice && !isNaN(originalUnitPriceCents)) {
        setVatBasePrice(originalPrice, ((originalUnitPriceCents * quantity) / 100).toFixed(2));
      }
    });

    const subtotal = document.querySelector('.js-cart-subtotal.vat-price');
    if (subtotal && subtotalCents > 0) {
      setVatBasePrice(subtotal, (subtotalCents / 100).toFixed(2));
    }
  }

  function applyPreference(scope = document) {
    syncCartPriceBaseData();
    updateToggleStates();
    updateLabelTexts();
    updatePrices(scope);
  }

  document.addEventListener('change', function (event) {
    if (!event.target.matches('.vat-toggle')) return;

    showIncVAT = event.target.checked;
    sessionStorage.setItem('vatPreference', showIncVAT ? 'inc' : 'exc');
    sessionStorage.setItem('vatPreferenceDefault', customerVatDefault);
    applyPreference();

    if (window.innerWidth <= 1050) {
      const drawerCloseBtn = document.querySelector('.drawer__close.js-drawer-close');
      if (drawerCloseBtn) {
        setTimeout(() => drawerCloseBtn.click(), 500);
      }
    }
  });

  document.body.addEventListener('theme:ajaxCart:updateSuccess', function () {
    window.setTimeout(function () {
      applyPreference();
    }, 0);
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('.js-cart-item-info-container .quantity__input')) return;

    window.setTimeout(function () {
      applyPreference();
    }, 150);
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.target.matches('.vat-price')) {
        applyPreference(mutation.target);
        return;
      }

      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;

        const hasVatContent =
          node.matches('.vat-price, .vat-toggle, [data-section-type="recommendations"], .boost-sd__product-item') ||
          node.querySelector('.vat-price, .vat-toggle, [data-section-type="recommendations"], .boost-sd__product-item');

        if (hasVatContent) {
          applyPreference(node);
        }
      });
    });
  });

  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['content', 'data-base-price'],
    childList: true,
    subtree: true
  });

  const reviewsConfigEl = document.getElementById('hansel-header-reviews-config');
  let reviewsConfig = null;

  if (reviewsConfigEl) {
    try {
      reviewsConfig = JSON.parse(reviewsConfigEl.textContent);
    } catch (error) {
      reviewsConfig = null;
    }
  }

  if (reviewsConfig && reviewsConfig.enabled !== false) {
    const reviewsDesktopQuery = window.matchMedia ? window.matchMedia('(min-width: 1051px)') : null;
    let reviewsWidgetStarted = false;

    const removeReviewsWidget = () => {
      document.querySelectorAll('.header__reviews-container').forEach((container) => {
        container.remove();
      });
    };

    const ensureReviewsWidget = () => {
      const existingWidget = document.querySelector('.header__reviews-container .reviews-io-rating-bar-widget');
      if (existingWidget) return existingWidget;

      const headerIcons = document.querySelector('.header__wrapper .header-icons.icon-wrapper, .header-icons.icon-wrapper');
      if (!headerIcons || !headerIcons.parentNode) return null;

      let container = document.querySelector('[data-review-container="true"]');
      if (!container) {
        container = document.createElement('div');
        container.className = 'header__search-container header__reviews-container';
        container.setAttribute('data-review-container', 'true');
        headerIcons.parentNode.insertBefore(container, headerIcons);
      }
      container.hidden = false;

      const wrapper = document.createElement('div');
      wrapper.className = 'header__reviews-rating';

      const widget = document.createElement('div');
      widget.className = 'reviews-io-rating-bar-widget';
      widget.setAttribute('widget-id', reviewsConfig.widgetId || '0r1OvesxyhztVC46');
      widget.setAttribute('data-store-name', reviewsConfig.storeName || 'hanselstone.co.uk');
      widget.setAttribute('lang', reviewsConfig.lang || 'en');

      wrapper.appendChild(widget);
      container.appendChild(wrapper);

      return widget;
    };

    const loadReviewsWidget = () => {
      if (document.querySelector('script[data-reviews-io-rating-bar]')) return;

      const script = document.createElement('script');
      script.src = 'https://widget.reviews.io/modern-widgets/rating-bar.js';
      script.defer = true;
      script.dataset.reviewsIoRatingBar = 'true';
      document.head.appendChild(script);
    };

    const startReviewsWidget = () => {
      if (reviewsDesktopQuery && !reviewsDesktopQuery.matches) {
        removeReviewsWidget();
        return;
      }

      const reviewsWidget = ensureReviewsWidget();
      if (!reviewsWidget || reviewsWidgetStarted) return;

      reviewsWidgetStarted = true;

      if ('IntersectionObserver' in window) {
        const reviewsObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            loadReviewsWidget();
            reviewsObserver.disconnect();
          });
        }, { rootMargin: '200px' });

        reviewsObserver.observe(reviewsWidget);
      } else if ('requestIdleCallback' in window) {
        window.requestIdleCallback(loadReviewsWidget, { timeout: 1500 });
      } else {
        window.addEventListener('load', loadReviewsWidget, { once: true });
      }
    };

    startReviewsWidget();

    if (reviewsDesktopQuery) {
      const handleReviewsViewportChange = (event) => {
        if (!event.matches) {
          removeReviewsWidget();
          return;
        }

        startReviewsWidget();

        if (reviewsDesktopQuery.removeEventListener) {
          reviewsDesktopQuery.removeEventListener('change', handleReviewsViewportChange);
        } else if (reviewsDesktopQuery.removeListener) {
          reviewsDesktopQuery.removeListener(handleReviewsViewportChange);
        }
      };

      if (reviewsDesktopQuery.addEventListener) {
        reviewsDesktopQuery.addEventListener('change', handleReviewsViewportChange);
      } else if (reviewsDesktopQuery.addListener) {
        reviewsDesktopQuery.addListener(handleReviewsViewportChange);
      }
    }
  }

  applyPreference();
});
